/**
 * Account Service — V2 Online Booking Engine
 *
 * Resolves the booking domain to an account. This is the first API call
 * the app should make to identify which property/account the user is booking at.
 *
 * Endpoint: POST /api/v2.0/online-booking/auth/account
 */

import { publicClient } from '@/services/httpClient'
import { API_VERSIONS, resolveApiPath } from '@/config/api'

const AUTH_PREFIX = resolveApiPath(`${API_VERSIONS.ONLINE_BOOKING}/auth`)

/**
 * Resolve the current domain to an account.
 *
 * @param {string} domain — The booking domain (e.g. "booking.myhostel.com")
 * @param {string} [slug] — Optional account slug (from the URL on shared domains)
 * @returns {Promise<Object>} Account data including account_id, branches, branding info
 */
export const resolveAccount = async (domain, slug) => {
  const body = { domain }
  if (slug) body.slug = slug
  const response = await publicClient.post(`${AUTH_PREFIX}/account`, body)
  return response?.data?.data ?? response?.data ?? {}
}
